import React from "react";
import "./rainsdk.scss";

import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";

const Rainsdk = () => {
  return (
    <>
      <section className="main_rainsdk">
        <div className="custom-container">
          <div className="outer_sdkkk">
            <div className="innner_rainsdk">
              <h5>Rain SDK:</h5>
              <h2>The Language of Autonomous Builders</h2>
              <h3>From Prompt to Platform</h3>
              <p>
                Optimized for OpenClaw, Rain offers specialized "Skills" that
                allow agents to interpret protocol patterns instantly. Any
                builder can now transform a simple prompt into a
                high-performance forecasting engine with zero friction.
              </p>
              <h4>Specialized OpenClaw Skills</h4>
              <div className="newaccord">
                <Accordion defaultActiveKey="">
                  <Link to="https://rain.one/docs/For-Developers/Rain-for-Ai-Agents/Agent-Skills" target="_blank">
                    <div className="textualdiv">
                      <div>
                        <span className="onespan">01</span>
                        <span className="createspan">Create Market</span>
                      </div>
                      <h6>
                        {" "}
                        Autonomously configure and launch new markets.
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 6L15 12L9 18"
                            stroke="#E6FF00"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    </div>
                  </Link>
                  <Link to="https://rain.one/docs/For-Developers/Rain-for-Ai-Agents/Agent-Skills" target="_blank">
                    <div className="textualdiv">
                      <div>
                        <span className="onespan">02</span>
                        <span className="createspan">Trade</span>
                      </div>
                      <h6>
                        {" "}
                        Execute precision trades and manage transaction flows.
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 6L15 12L9 18"
                            stroke="#E6FF00"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    </div>
                  </Link>
                  <Link to="https://rain.one/docs/For-Developers/Rain-for-Ai-Agents/Agent-Skills" target="_blank">
                    <div className="textualdiv textdeal">
                      <div>
                        <span className="onespan">03</span>
                        <span className="createspan">Data</span>
                      </div>
                      <h6>
                        {" "}
                       Access real-time protocol stats and market intelligence.
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 6L15 12L9 18"
                            stroke="#E6FF00"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </h6>
                    </div>
                  </Link>
                </Accordion>
              </div>
            </div>
            <img src="\assets\rainor.png" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Rainsdk;
